import gsap from "gsap";
import { ScrollTrigger, Draggable } from "gsap/all";
import TenByTenMoonAnimation from "./TenByTenMoonAnimation";

//TODO:
// - Refatorar
// - Tentar aplicar draggable no mobile
// - Refinar e ajustar animacões

export default class TenByTenVideosSlider {
	constructor() {
		this.videosHolder = document.querySelector(".tenbyten-videos__videos");

		if(!this.videosHolder) return;
		gsap.registerPlugin(ScrollTrigger, Draggable);

		this.videos = this.videosHolder.querySelectorAll(".tenbyten-card");
		this.firstCardWidth = document.querySelector(".tenbyten-videos__videos .tenbyten-card > *").clientWidth;
		this.firstCardHeight = document.querySelector(".tenbyten-videos__videos .tenbyten-card > *").clientHeight;
		this.positions = Array.from(this.videos).map((el, i) => i);
		this.width = [];
		this.moonRotation = new TenByTenMoonAnimation();
		this.moon = this.moonRotation.moon;
		this.initialPositionsRun = false;
		this.desktopBreakpoint = window.mediaQueries.breakUp.l;
		this.isMobile = window.mediaQueries.mediaBreakDown('l');
		this.mobileActive = 0;

		this.init();
	}

	init() {
		this.enteringAnimation();
		this.setTallerVideoTitleHeightCSSVar();
	}

	setVideoTitleHeightCSSVar(current) {
		const title = this.videos[current].querySelector('h3');

		document.querySelector('.tenbyten-videos').style.setProperty('--title-height', title.clientHeight + 'px');
	}

	setTallerVideoTitleHeightCSSVar() {
		const titlesHeight = Array.from(this.videos).map(el => el.querySelector('h3').clientHeight)

		document.querySelector('.tenbyten-videos').style.setProperty('--taller-title-height', Math.max(...titlesHeight) + 'px');
	}

	positionElements(parentContainerSelector, elementsSelector, progress = 0) {
		const parentContainer = document.querySelector(parentContainerSelector);
		const elements = parentContainer.querySelectorAll(elementsSelector);

		if (!parentContainer || elements.length === 0) {
			console.error("Parent container or elements not found");
			return;
		}

		const totalWidth = parentContainer.clientWidth;
		const widths = [];
		const xPositions = [0];

		parentContainer.style.setProperty('--card-width', this.firstCardWidth + 'px');
		parentContainer.style.setProperty('--card-height', this.firstCardHeight + 'px');

		const sliderTl = gsap.timeline();

		elements.forEach((element, index) => {

			let state = -1 * (progress * (elements.length - 1) - index);

			const widthPercentage = 100 - (Math.abs(state) * 32);

			let widthPixels = Math.max(0, (widthPercentage / 100) * totalWidth);
			widths.push(widthPixels);

			if (index < elements.length - 1) {
				xPositions.push(xPositions[index] + widthPixels);
			}

			const positionsObj = {
				width: `${Math.max(0, widthPixels)}px`,
				x:`${xPositions[index]}px`,
				y: `${this.firstCardHeight * Math.abs(state) * .8}`,
				rotation: state * 10,
				'--opacity': Math.max(0, 1 - (Math.abs(state) / 3)),
			}

			if(!this.initialPositionsRun) {
				const slideAnim =  gsap.to(element, {
					...positionsObj,
					delay: index * .1,
					duration: 1.3,
					ease: "power2.out",
				})

				sliderTl.add(slideAnim, this.isMobile && '=<');

			} else {
				gsap.set(element, positionsObj)
			}
		});

		this.initialPositionsRun = true;

		return {
			widths,
			xPositions
		};
	}

	containerAnim() {
		let { widths } = this.initialValues;
		widths.shift();

		const accWidths = (widthsArr, currentIndex) => {
			if (currentIndex === 0) return widthsArr[0];

			return widthsArr[currentIndex] + accWidths(widthsArr, currentIndex - 1);
		}

		const createTween = (index) => {
			const amount = accWidths(widths, index);

			return gsap.to(this.videosHolder, {
				x: () => `${-amount}px`,
			})
		}

		const tl = gsap.timeline({paused: true, ease: "none"});

		widths.forEach((curr, index) => {
			tl.add(createTween(index));
		});

		return tl;
	}

	enteringAnimation() {
		const moonLeaving = gsap.timeline({paused: true});
		const mm = gsap.matchMedia();

		mm.add({
			isMobile: window.mediaQueries.breakDown.l,
			isDesktop: window.mediaQueries.breakUp.l
		}, ctx => {

			const { isMobile, isDesktop } = ctx.conditions;

			moonLeaving
				.call(() => {
					this.moon.style.removeProperty('margin-top')
					this.moon.style.removeProperty('transition')
				})
				.to(this.moon, {
					yPercent: -110,
				})
				.set(this.moon, {
					transition: "none",
					yPercent: 0,
					xPercent: -50,
					top: '100%',
					left: '50%',
					marginTop: 0,
					scaleX: 1,
					scaleY: -1,
					position: isMobile && 'absolute'
				})
				.to(this.moon, {
					yPercent: isMobile ? -52 : -42,
					opacity: 1,
					immediateRender: false,
					duration: .5,
					overwrite: "all"
				})
		})

		const enteringTl =
			gsap.timeline({
				onComplete: () => {
					setTimeout(() => {
						this.setActiveItem(0);
					}, 50);
				}
			});

		enteringTl
			.fromTo('.tenbyten-videos .tenbyten-videos__logo', {
				scale: 0,
				autoAlpha: 0
			}, {
				scale: 1,
				autoAlpha: 1,
				duration: 1.5,
				ease: "power2.out",
			})
			.fromTo(['.tenbyten-videos .tenbyten-videos__nav', '.tenbyten-videos .tenbyten-videos__grid-view-toggle'], {
				autoAlpha: 0
			}, {
				autoAlpha: 1,
				duration: 1,
			}, '=<')
			.fromTo('.tenbyten-videos .tenbyten-card', {
				scale: .5,
				autoAlpha: 0
			}, {
				scale: 1,
				autoAlpha: 1,
				duration: 1.3,
				ease: "power2.out",
			}, '=<')
			.call(() => {
				this.initialValues = this.positionElements(".tenbyten-videos__videos", ".tenbyten-card");

				this.scrollVideos();
				this.mobileSlider();
			}, [], '=<');

		ScrollTrigger.create({
			trigger: '.tenbyten-videos',
			start: 'top 30%',
			animation: enteringTl,
			onEnter: () => {
				moonLeaving.play();
			},
			onLeaveBack: () => {
				moonLeaving.reverse();
				this.isMobile && gsap.set(this.moon, {position: 'fixed', delay: 1});
			}
		})
	}

	onEnterScrollArea() {
		document.querySelector('html').classList.add('-force-hide-menu');
	}

	onLeaveScrollArea() {
		document.querySelector('html').classList.remove('-force-hide-menu');
	}

	scrollVideos() {

		let mm = gsap.matchMedia();

		const max = Array.from(this.videos).reduce((acc, curr) => {
			return acc + curr.offsetWidth;
		}, 0);

		const moonLeaving = gsap.timeline({paused: true});

		moonLeaving
			.to(this.moon, {
				yPercent: 100,
				duration: 2
			})

		mm.add(this.desktopBreakpoint, () => {
			this.sliderAnim = ScrollTrigger.create({
				trigger: ".tenbyten-videos__holder",
				start: "top top",
				end: () => "+=" + max * 2,
				scrub: 0,
				pin: true,
				pinnedContainer: ".tenbyten-videos",
				ease: 'none',
				snap: {
					snapTo: .11111111111,
					duration: { min: 0.2, max: 1 }
				},
				animation: this.containerAnim(),
				onEnter: () => {
					this.onEnterScrollArea();
				},
				onEnterBack: () => {
					this.onEnterScrollArea();
					moonLeaving.reverse();
				},
				onLeave: () => {
					this.onLeaveScrollArea();
					moonLeaving.play();
				},
				onLeaveBack: () => {
					this.onLeaveScrollArea();
				},
				onUpdate: (self) => {
					this.positionElements(".tenbyten-videos__videos", ".tenbyten-card", self.progress);
					this.setActiveItem(self.progress);
				},
			});
		});
	}

	mobileSlider() {
		if(!this.isMobile) return

		this.containerAnimTl = this.containerAnim();
		this.updateMobileActive(0);
		this.dragMobileSlider();

		window.addEventListener('click', e => {
			if(e.target.classList.contains('tenbyten-videos__nav__prev') || e.target.classList.contains('tenbyten-videos__nav__next')) {
				const prevBtn = document.querySelector('.tenbyten-videos__nav__prev');
				const nextBtn = document.querySelector('.tenbyten-videos__nav__next');

				this.initialPositionsRun = false;

				if(e.target === prevBtn) {
					if(this.mobileActive <= 0) {
						return;
					}

					const prev = Math.max(0, (this.mobileActive - 1) / 9);

					e.target.classList.remove('disabled');

					this.positionElements(".tenbyten-videos__videos", ".tenbyten-card", prev);

					this.containerAnimTl.progress(prev);
					this.mobileActive--;
				}

				if(e.target == nextBtn) {
					if(this.mobileActive >= this.videos.length - 1) {
						e.target.classList.add('disabled');
						return
					};

					const next = (this.mobileActive + 1) / 9;

					e.target.classList.remove('disabled');

					this.positionElements(".tenbyten-videos__videos", ".tenbyten-card", next);
					this.containerAnimTl.progress(next);

					this.mobileActive++;
				}

				this.updateMobileActive(this.mobileActive);
			}

			return
		});
	}

	dragMobileSlider() {
		const tl = this.containerAnimTl;
		let currProgress = tl.progress();
		let progress = 0;
		let endDrag = { progress: 0 };
		let dragProgressAnim = null;

		const dragger = document.querySelector(".tenbyten-videos");
		const draggerContainer = document.querySelector(".tenbyten");

		const containerWidth = draggerContainer.offsetWidth;
		const that = this;

		Draggable.create(dragger, {
			type: "x",
			trigger: draggerContainer,
			onDragStart: function() {
				currProgress = tl.progress();
				dragProgressAnim && dragProgressAnim.kill();
			},
			onDrag: function() {
				progress = Math.max(0, Math.min(1, currProgress + ((this.startX - this.x) * .5 / containerWidth)));

				tl.progress(progress);
				that.positionElements(".tenbyten-videos__videos", ".tenbyten-card", progress);

				gsap.set(that.videosHolder, {transition: "none"});
			},
			onDragEnd: function() {
				endDrag.progress = progress;

				const snappedProgress = gsap.utils.snap(0.111111111, progress);
				const endValue = gsap.utils.interpolate(0, 1, snappedProgress);
				const current = Math.ceil(endValue * (that.videos.length - 1))
				that.mobileActive = current;

				that.updateMobileActive(current);
				gsap.set(this.target, {x: 0});

				dragProgressAnim = gsap.to(endDrag, {
					progress: endValue,
					ease: 'none',
					duration: .3,
					onUpdate: () => {
						tl.progress(endDrag.progress);
						that.positionElements(".tenbyten-videos__videos", ".tenbyten-card", endDrag.progress);
					},
					onComplete: () => {
						gsap.set(that.videosHolder, {clearProps: "transition"});
					}
				});
			}
		});
	}

	updateMobileActive(current) {
		this.videos.forEach(el => el.classList.remove('active'));
		this.videos[current].classList.add('active');

		this.updateMobileNav(current);
		this.setVideoTitleHeightCSSVar(current);
	}

	updateMobileNav(current) {
		const prevBtn = document.querySelector('.tenbyten-videos__nav__prev');
		const nextBtn = document.querySelector('.tenbyten-videos__nav__next');

		prevBtn.classList.remove('disabled');
		nextBtn.classList.remove('disabled');

		if(current <= 0) {
			prevBtn.classList.add('disabled');
		}

		if(current >= this.videos.length - 1) {
			nextBtn.classList.add('disabled');
		}
	}

	setActiveItem(progress) {
		const progressIndex = progress * (this.videos.length - 1);
		this.videos.forEach((element, index) => {
			const isActive = progressIndex + .3 >= index && progressIndex + .3 < (index + 1);
			element.classList.toggle("active", isActive);
		})
	}
}
